// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f6b12881","248":"87f84c20","455":"b914bb78","977":"7fc48deb"}[chunkId] + ".chunk.js";
};